import { render, staticRenderFns } from "./MassiveImportInfoCollaboratorProjectDetailModal.vue?vue&type=template&id=ec515bec&scoped=true&"
import script from "./MassiveImportInfoCollaboratorProjectDetailModal.vue?vue&type=script&lang=js&"
export * from "./MassiveImportInfoCollaboratorProjectDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./MassiveImportInfoCollaboratorProjectDetailModal.vue?vue&type=style&index=0&id=ec515bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec515bec",
  null
  
)

export default component.exports